<template>
  <div>
    <el-row>
      <el-col :span="6" style="max-width: 160px">
        <label
          style="vertical-align: middle; margin-left: 0.5em; margin-bottom: 2em; font-size: 14px"
          class="has-text-grey"
        >
          {{ setting.label || name }}
          <Tooltip :label="setting.label || name" :content="setting.detail" />
        </label>
      </el-col>
      <el-col :span="22" style="max-width: 540px; margin-left: 0.5em">
        <YAMLEditor ref="yamlEditor" v-model="value[name]" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
/**
 * Yaml SmartField - Renders a YAML editor for object/array configuration values.
 *
 * @component
 * @description Displays a rich YAML editor with syntax highlighting, validation, and formatting.
 * Uses the YAMLEditor component to provide a developer-friendly interface for editing
 * configuration in YAML format.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the YAML editor (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Object|string} [setting.default] - Default YAML value if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Yaml
 *   :value="config"
 *   :setting="{
 *     label: 'Configuration',
 *     detail: 'Edit YAML configuration',
 *     default: { service: 'api', port: 8080 }
 *   }"
 *   name="yamlConfig"
 * />
 */
import YAMLEditor from "@/components/YAMLEditor";
import Tooltip from "../Tooltip.vue";
export default {
  props: ["value", "setting", "name"],
  components: {
    YAMLEditor,
    Tooltip,
  },
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
